import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import { Row, Col, Card, CardBody } from "reactstrap"
import { AllRecordingsQuery } from "../Drivers/Driver/Detail/Queries"
import { HasPermissionsQuery } from "../Functions/querys"
import withApolloClient from '../withApolloClient'
import Loader from "./Loader"
import DatetimeRenderer from "./DatetimeRenderer"
import { Link } from "react-router-dom"
import "./DashcamContainer.css"


class DashcamContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            isLoading: false,
            isReloading: false
        }
    }

    handleLoadMore = () => {
        this.setState({ isLoading: true })
        this.props.loadMoreEntries().finally(() => {
            this.setState({ isLoading: false })
        })
    }

    handleReload = () => {
        this.setState({ isReloading: true })
        this.props.refetchQuery().finally(() => {
            this.setState({ isReloading: false })
        })
    }

    render() {
        const { allDashcamRecordings, allDashcamRecordsLoading, loadMore } = this.props
        const { isLoading, isReloading } = this.state


        if (allDashcamRecordsLoading) {
            return <p className="info-container">< Loader /></p>
        }

        if (!allDashcamRecordings?.edges?.length) {
            return <p className="info-container">No dashcam recordings found.</p>
        }

        return (

            <div className="info-container">
                <Row>
                    {this.props.allDashcamRecordings.edges.map((file, idx) => (
                        <Col md="4" className="mb-4" key={file.id || idx}>
                            <Card className="dashcam-card">
                                <CardBody>
                                    <div className="dashcam-card-header">
                                        <span className="video-title"><i className="fa fa-video-camera mr-1" />{idx + 1}. {file?.node?.viewingAngle}</span>
                                        {this.props.carId && file?.node?.dashcamRecord?.agreement && (
                                            <span className="driver-link"><Link to={`/driver/${file?.node?.dashcamRecord?.agreement?.driver?.id}`} target="_blank">{file?.node?.dashcamRecord?.agreement?.driver?.name}&nbsp;<i className="fa fa-external-link color-blue"></i></Link></span>
                                        )}
                                        <span className="video-date"><DatetimeRenderer datetime={file.node.dateAdded} /> </span>
                                    </div>
                                    <div className="video-container">
                                        <video className="video-box" src={file.node.url} controls width="100%" />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <div className="dashcam-footer">
                    {this.props.refetchQuery && (
                        <button className="btn btn-link" onClick={this.handleReload} disabled={isReloading}><i className="fa fa-refresh"></i>&nbsp;{isReloading ? "Reloading..." : "Reload"}</button>
                    )}

                    {allDashcamRecordings?.pageInfo?.hasNextPage && this.props.loadMoreEntries && (
                        <button className="btn btn-link float-right" onClick={this.handleLoadMore} disabled={isLoading}><i className="fa fa-angle-double-down"></i>&nbsp;{isLoading ? "Loading..." : "Load More"}</button>
                    )}
                </div>
            </div>
        )
    }
}


export default graphql(HasPermissionsQuery, {
    options: () => ({
        variables: {
            userPermissions: ['view_dashcam_record']
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions,
        loading,
        variables,
    }),
})(
    graphql(AllRecordingsQuery, {
        options: ({ carId, rentalId, incidentDate }) => {
            let variables = {
                carId: carId,
                rentalId: rentalId || null,
                incidentDate: incidentDate || null,
            }
            variables.first = rentalId ? 3 : 6
            return {
                variables,
                fetchPolicy: 'cache-and-network',
            }
        },
        props: ({ data: { loading, allDashcamRecordings, fetchMore, variables } }) => ({
            allDashcamRecordsLoading: loading,
            allDashcamRecordings,
            variables,
            refetchQuery: () => {
                return fetchMore({
                    query: AllRecordingsQuery,
                    variables: {
                        ...variables,
                        first: allDashcamRecordings?.edges?.length || variables.first,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        if (!fetchMoreResult) return previousResult
                        return {
                            allDashcamRecordings: {
                                edges: [...fetchMoreResult.allDashcamRecordings.edges],
                                pageInfo: fetchMoreResult.allDashcamRecordings.pageInfo,
                                __typename: previousResult.allDashcamRecordings.__typename,
                            },
                        }
                    },
                })
            },
            loadMoreEntries: () => {
                return fetchMore({
                    query: AllRecordingsQuery,
                    variables: {
                        ...variables,
                        first: variables.first,
                        after: allDashcamRecordings?.pageInfo?.endCursor || null,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        if (!fetchMoreResult) return previousResult
                        return {
                            allDashcamRecordings: {
                                edges: [
                                    ...previousResult.allDashcamRecordings.edges,
                                    ...fetchMoreResult.allDashcamRecordings.edges,
                                ],
                                pageInfo: fetchMoreResult.allDashcamRecordings.pageInfo,
                                __typename: previousResult.allDashcamRecordings.__typename,
                            },
                        }
                    },
                })
            },


        }),
    })(withApolloClient(DashcamContainer))
)


